<div (appClickOutside)="onClickOutside()" [ngClass]="changePosition ? 'select-date-position-bottom' : 'select-date-position-top'" [class.hide-input]="hideInput">
	<input type="text" [class.error]="showError" (click)="open()" readonly="readonly"
		[attr.disabled]="isDisabled ? isDisabled : null" [ngClass]="{'expand': expand}"
		[placeholder]="placeholder || hidePlaceholder ? placeholder : getPlaceholderDefault()"
		[value]="withTime && !hideTime && value ? (value | date : 'short') : value ? (value | date : 'shortDate') : null">

	<app-icon (click)="open()">insert_invitation</app-icon>

	<app-select-date 
		*ngIf="expand && !isDisabled" 
		[value]="value"
		[disableSelectDate]="disableSelectDate"
		[withTime]="withTime"
		[hideTime]="hideTime"
		[dayLimit]="dayLimit"
		[isDateLimit]="isDateLimit"
		[errorOverlay]="errorOverlay"
		[hideClearButton]="hideClearButton"
		(appSetNewDate)="setNewDate($event)" (appClear)="clear()" (appSetTime)="setTime($event)"
		(appEnter)="selectDate($event)">
	</app-select-date>
</div>
